import refreshDashboards from 'common/src/modules/campaigns/store/insightsTab/actions/refreshDashboards';
import refreshWidgets from 'common/src/modules/campaigns/store/insightsTab/actions/refreshWidgets';
import dashboardsApi from 'common/src/modules/dashboards/dashboards.api';
import {
  AiDashboardWidgetType,
  DashboardWidget,
  DashboardWidgetType,
} from 'common/src/modules/dashboards/dashboards.types';
import widgetNameByMetricsAndDimensions from 'common/src/modules/dashboards/utils/widgetNameByMetricsAndDimensions';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {CLStore} from 'common/src/redux/store';
import getMatchingEnumValue from 'common/src/utils/typescriptUtils/getMatchingEnumValue';
import {AnalyticsEventType, DimensionValue} from '../../../../analytics.types';
import getRemoteDimensionKey from '../../../../utils/getRemoteDimensionKey';
import {copilotAnalyticsWidgetSchema} from '../../../copilotAnalytics.schemas';
import {CampaignAnalyticsToolName} from '../campaignAnalyticsAgent.enums';
import {FeatureFlagKey} from 'common/src/modules/featureFlags/featureFlags.types';
import isFlagEnabled from 'common/src/modules/featureFlags/utils/isFlagEnabled';

function createWidgetTool(store: CLStore) {
  async function execute({
    input: {dashboardId, dimension: aiDimension, metrics, breakdownByTime, type, withTrends},
  }: ToolExecuteParams<typeof copilotAnalyticsWidgetSchema>) {
    const {
      campaignPage: {
        insightsTab: {availableDimensions},
      },
    } = store.getState();
    const dimension =
      getRemoteDimensionKey<DimensionValue>(availableDimensions, aiDimension) ??
      DimensionValue.Date;

    const widgetType = getMatchingEnumValue(AiDashboardWidgetType, DashboardWidgetType, type);

    const widget: DashboardWidget = {
      id: 0,
      dashboardId,
      filters: [],
      name: widgetNameByMetricsAndDimensions(
        metrics,
        [dimension as DimensionValue],
        widgetType as DashboardWidgetType,
      ),
      breakdownByTime: breakdownByTime,
      type: widgetType as DashboardWidgetType,
      dimensions: [dimension as DimensionValue],
      metrics,
      config: [],
      layout: {
        i: String(0),
        x: 1,
        y: 1,
        w: 0,
        h: 0,
      },
      children: [],
      showTrends: withTrends ?? false,
      eventType: AnalyticsEventType.Adserving,
    };

    try {
      const widgetId = await dashboardsApi.createWidget({...widget, dashboardId});

      await store.dispatch(refreshDashboards());
      await store.dispatch(refreshWidgets({dashboardId}));

      const isSkillsMode = isFlagEnabled(FeatureFlagKey.EnableCopilotSkills);

      if (isSkillsMode) {
        return toolResult(String(widgetId));
      }

      return toolResult(`Created widget with id: ${widgetId}`);
    } catch (error) {
      return toolError(
        `Failed to create widget: ${error instanceof Error ? error.message : 'Unknown error'}`,
      );
    }
  }

  return tool({
    name: CampaignAnalyticsToolName.CreateWidget,
    displayName: 'Creating widget',
    description: 'create a dashboard widget',
    execute,
    inputSchema: copilotAnalyticsWidgetSchema,
  });
}

export default createWidgetTool;
